<template>
  <el-dialog
    :visible.sync="display"
    width="30%"
    :modal-append-to-body="false"
    center
  >
    <div class="logo">
      <img class="image" :src="imagePath" />
    </div>

    <p class="description">
      {{ $t(integration.description) }}
    </p>

    <p class="active-connections" v-if="connectionsNumber > 0">
      <router-link :to="createdConnectionsRoute">
        {{
          $tc(
            'Integrations_Text_NumberIntegrationsAlreadyConfigured',
            connectionsNumber,
            {
              number: connectionsNumber
            }
          )
        }}
      </router-link>
    </p>

    <span
      slot="footer"
      class="dialog-footer"
      v-if="showRequestButton || showConnectButton"
    >
      <el-tooltip
        :disabled="!isConnectButtonDisabled"
        effect="light"
        :content="configuredIntegrationTooltip"
        placement="bottom"
      >
        <span>
          <el-button
            v-if="showConnectButton"
            type="primary"
            @click="goToCreate"
            :disabled="isConnectButtonDisabled"
          >
            {{ connectButtonLabel }}
          </el-button>
        </span>
      </el-tooltip>

      <el-button
        v-if="showRequestButton"
        type="primary"
        @click="requestConnection"
        :loading="loading"
      >
        {{ requestButtonLabel }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectRoute, projectEndpoint } from '@/core/helpers'
import Integrations from '@/modules/integrations/types'

export default {
  name: 'IntegrationPopup',

  props: {
    integration: {
      type: Object,
      required: true
    },
    connectionsNumber: {
      required: true
    },
    dynamicIntegrationId: {
      type: Number,
      required: false
    }
  },

  data() {
    return {
      display: false,
      loading: false,
      Integrations
    }
  },

  computed: {
    createdConnectionsRoute() {
      const query = this.getQuery()
      return projectRoute({
        name: 'IntegrationsList',
        query
      })
    },

    createRoute() {
      const query = this.getQuery()
      let integrationType = Integrations[this.integration.type]
      if (integrationType === undefined) {
        integrationType = Integrations['dynamicpromotions']
      }
      if (integrationType.stepped) {
        return projectRoute({
          name: 'IntegrationSteppedCreate',
          query
        })
      } else {
        return projectRoute({
          name: 'IntegrationCreate',
          query
        })
      }
    },

    imagePath() {
      return this.integration.image
    },

    showConnectButton() {
      if (this.integration.requiresAdmin && !this.$isRole('admin')) {
        return false
      }

      return this.$can('manageProjectTechnical')
    },

    isConnectButtonDisabled() {
      return (
        this.gigConfigured ||
        this.betssonConfigured ||
        this.oasisConfigured ||
        this.comeOnConfigured
      )
    },

    showRequestButton() {
      return (
        this.integration.requiresAdmin &&
        !this.$isRole('admin') &&
        this.$can('manageProjectTechnical')
      )
    },

    connectButtonLabel() {
      return this.connectionsNumber > 0
        ? this.$t('Integrations_Button_ConnectNew')
        : this.$t('Integrations_Button_Connect')
    },

    requestButtonLabel() {
      if (this.loading) {
        return this.$t('Integrations_Button_Requesting')
      }

      return this.connectionsNumber > 0
        ? this.$t('Integrations_Button_RequestNew')
        : this.$t('Integrations_Button_Request')
    },

    gigConfigured() {
      return this.integration.type === 'gig' && this.connectionsNumber > 0
    },

    betssonConfigured() {
      return this.integration.type === 'betsson' && this.connectionsNumber > 0
    },

    oasisConfigured() {
      return this.integration.type === 'oasis' && this.connectionsNumber > 0
    },

    comeOnConfigured() {
      return this.integration.type === 'comeon' && this.connectionsNumber > 0
    },

    configuredIntegrationTooltip() {
      if (this.comeOnConfigured) {
        return this.$t('Integrations_ComeOn_Configured_ToolTip')
      }
      if (this.oasisConfigured) {
        return this.$t('Integrations_Oasis_Configured_ToolTip')
      }
      if (this.betssonConfigured) {
        return this.$t('Integrations_Betsson_Configured_ToolTip')
      }
      return this.$t('Integrations_Gig_Configured_ToolTip')
    }
  },

  methods: {
    show() {
      this.display = true
    },

    hide() {
      this.display = false
    },

    goToCreate() {
      if ('connectUrl' in this.integration) {
        window.location.href = this.integration.connectUrl(
          window.location.origin,
          this.$route.query.project_id
        )
      } else {
        this.$router.push(this.createRoute)
      }
    },

    requestConnection() {
      this.startLoading()
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `integrations/request`,
          params: {
            type: this.integration.type
          }
        })
      )
        .then(() => {
          this.stopLoading()
          this.hide()
          this.$emit('on-request-success')
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
          this.stopLoading()
          this.hide()
        })
    },

    startLoading() {
      this.loading = true
    },

    stopLoading() {
      this.loading = false
    },

    getQuery() {
      if (!this.dynamicIntegrationId) {
        return {
          type: this.integration.type
        }
      } else {
        return {
          dynamic_integration_id: this.dynamicIntegrationId
        }
      }
    }
  }
}
</script>

<style scoped>
.logo {
  margin: auto;
  height: 160px;
  width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image {
  max-width: 90%;
  max-height: 100%;
}

.description {
  font-size: 13px;
  line-height: 24px;
  text-align: center;
  color: #808080;
  word-break: break-word;
}

.active-connections {
  font-size: 13px;
  line-height: 24px;
  text-align: center;
  color: #808080;
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/components/IntegrationPopup.vue